import React from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { formatDate, BOOKING_STATUS } from "@/lib/format";
import { StatusBadge } from "@/components/StatusBadge";

export default function PreparationPage() {
  const [rows, setRows] = React.useState([]);
  React.useEffect(() => { (async () => { const { data } = await api.get("/warehouse/preparation"); setRows(data); })(); }, []);
  return (
    <div className="space-y-4" data-testid="preparation-page">
      <div>
        <h1 className="text-3xl font-bold tracking-tight" style={{ fontFamily: "Manrope, sans-serif" }}>Persiapan Gudang</h1>
        <p className="text-sm text-neutral-500">Booking yang perlu disiapkan / dicek-out.</p>
      </div>
      <div className="card-flat overflow-x-auto">
        <table className="w-full data-table">
          <thead><tr>
            <th className="text-left">No. Booking</th>
            <th className="text-left">Pelanggan</th>
            <th className="text-left">Project</th>
            <th className="text-left">Prep Date</th>
            <th className="text-left">Mulai Sewa</th>
            <th className="text-right">Item</th>
            <th className="text-left">Status</th>
            <th></th>
          </tr></thead>
          <tbody>
            {rows.map((b) => (
              <tr key={b.id} data-testid={`prep-row-${b.id}`}>
                <td className="font-mono text-xs">{b.number}</td>
                <td data-testid={`prep-customer-${b.id}`}>{b.customer_name || "-"}</td>
                <td>{b.project_name || "-"}</td>
                <td className="text-xs">{formatDate(b.prep_date)}</td>
                <td className="text-xs">{formatDate(b.start_date)}</td>
                <td className="text-right">{(b.items || []).length}</td>
                <td><StatusBadge statusMap={BOOKING_STATUS} value={b.status} /></td>
                <td className="text-right"><Link to={`/checkout/${b.id}`} className="text-green-700 text-xs hover:underline" data-testid={`prep-checkout-${b.id}`}>Check-Out →</Link></td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={8} className="text-center py-8 text-sm text-neutral-500">Tidak ada booking untuk disiapkan.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
